import { Modal } from 'react-bootstrap'
import { ModalHeaderProps } from 'react-bootstrap/ModalHeader'
import classNames from 'classnames'
import styles from './WarningModalHeader.module.scss'

export const WarningModalHeader = (props: ModalHeaderProps) => (
  <Modal.Header
    closeButton
    {...props}
    className={classNames(
      `${styles.warningModalHeader} d-flex align-items-center`,
      props.className
    )}
    ref={undefined}
  />
)
